/**
 * The three offerings, in one place so pages, pricing and gates never drift apart.
 *  - Professional Tools: single-task tools (batch jobs where the tool supports them).
 *  - Premium Applications: the multi-step apps. A Premium Applications plan also unlocks every Professional Tool.
 *  - Workflow Products: dedicated products, each with its own price, storage, AI, landing page and subdomain.
 */
import { PROFESSIONAL_TRIAL_LIMIT, PREMIUM_TRIAL_LIMIT } from "@shared/tiers";

export type Tier = "professional" | "premium" | "product";

export const PROFESSIONAL = { name: "Professional Tools", href: "/professional-tools", trials: PROFESSIONAL_TRIAL_LIMIT, dayPass: "$1", monthly: "$4.99" } as const;
export const PREMIUM_APPS = { name: "Premium Applications", href: "/premium-apps", trials: PREMIUM_TRIAL_LIMIT, dayPass: "$3", monthly: "$9.99" } as const;
export const WORKFLOW_PRODUCTS = { name: "Workflow Products", href: "/workflow-products" } as const;

import { PREMIUM_APP_IDS, WORKFLOW_PRODUCT_IDS, isPremiumApp } from "@shared/tiers";
export { PREMIUM_APP_IDS, WORKFLOW_PRODUCT_IDS, isPremiumApp };

const products = new Set<string>(WORKFLOW_PRODUCT_IDS);
export const isWorkflowProduct = (id: string | undefined) => !!id && products.has(id);

/** Which offering a tool belongs to. Everything not listed as Premium or a Workflow Product is a Professional Tool. */
export function tierOf(id: string | undefined): Tier {
  if (isWorkflowProduct(id)) return "product";
  if (isPremiumApp(id)) return "premium";
  return "professional";
}
